import { cn } from '@/lib/utils'

type ColorDotProps = {
  color?: string | null
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

export function ColorDot({ color, size = 'sm', className }: ColorDotProps) {
  return (
    <span
      className={cn(
        'inline-block shrink-0 rounded-full',
        size === 'xs' && 'size-1.5',
        size === 'sm' && 'size-2',
        size === 'md' && 'size-3',
        !color && 'border border-muted-foreground',
        className,
      )}
      style={color ? { backgroundColor: color } : undefined}
    />
  )
}
